import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SdvorLinkComponent } from '@sdvor/shared/ui';
import { UrlModule } from '@spartacus/core';
import { WishlistContentEmptyComponent } from './wishlist-content-empty.component';

@NgModule({
  imports: [RouterLink, UrlModule, SdvorLinkComponent],
  declarations: [WishlistContentEmptyComponent],
  exports: [WishlistContentEmptyComponent],
})
export class WishlistContentEmptyModule {}
